/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Injectable } from '@angular/core';

import { TextModel } from '@typescript-kit/view';
import { ViewService } from '@angular-kit/view';

import { TimeRecordingViewModel } from '../view-model/time-recording.view-model';
import { TimeRecordingSidebarModel } from '../component-model/time-recording-sidebar.component-model';
import { EmployeeTimeRecordingSummaryViewService } from './employee-time-recording-summary.view-service';
import { TimeRecordingComponentKey } from '../key/time-recording-component.key';
import { EmployeeTimeRecordingWorkingHoursViewService } from './employee-time-recording-working-hours.view-service';
import { EmployeeTimeRecordingSharedViewService } from './employee-time-recording-shared.view-service';

@Injectable()
export class EmployeeTimeRecordingSidebarViewService extends ViewService<TimeRecordingViewModel, TimeRecordingSidebarModel> {
  private readonly sharedViewService = this.injector.get(EmployeeTimeRecordingSharedViewService);
  private summaryViewService = new EmployeeTimeRecordingSummaryViewService(this.injector);
  private workingHoursViewService = new EmployeeTimeRecordingWorkingHoursViewService(this.injector);

  initialize(): void {
    const viewModel = this.sharedViewService.viewModel;
    this.summaryViewService.initialize(viewModel);
    this.workingHoursViewService.initialize(viewModel);
    super.initialize(viewModel);
  }

  finalize(): void {
    this.summaryViewService.finalize();
    this.workingHoursViewService.finalize();
    super.finalize();
  }

  protected createComponentModel(): TimeRecordingSidebarModel {
    return new TimeRecordingSidebarModel({
      summaryHeader: this.createContentHeader('summary'),
      summary: this.summaryViewService.componentModel,
      workingHoursHeader: this.createContentHeader('workingHours'),
      workingHours: this.workingHoursViewService.componentModel,
    });
  }

  protected refreshComponentModel(model: TimeRecordingSidebarModel) {
  }

  private createContentHeader(key: string): TextModel {
    return new TextModel({
      key, text: `${TimeRecordingComponentKey.TIME_RECORDING_SIDEBAR}/${key}`
    });
  }

}
